export const useData = () => {
    const resetData = (ref, initialRef) => {
        if ("object" == typeof initialRef) {
            for (const key of Object.keys(ref)) {
                if (Array.isArray(initialRef[key])) ref[key] = []
                else ref[key] = initialRef[key] || null
            }
        } else {
            ref = initialRef
        }
    }

    return {
        resetData,
    }
}
